import { PendingBillsModel } from 'one-card-pending-bills';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 *Pending Bills Component
 * @param response has the backend
 * pending bills response
 * @param context has settings etc...
 */


export const TransformResponse = (response: any, context: any) => {

    /**
     * @param result contains the transformed response
     */
    let pendingbills: PendingBillsModel = { totalpendingbills: 0, totalbalance: "0", insurancebalance: "0"};

    let result: any = {
        bills: pendingbills,
        error: undefined

    }
    console.log("The total pending bills are: ", response)

    
        let insurancebalance = 0;
        let patientbalance = 0;
        let totalpendingbills=0;
        let servicearea = "";
            let res=response
            if(res?.claimbalancedetails?.length>0){

                res?.claimbalancedetails?.map((account: any) => {
    
                    account?.claimdetails?.map((claim: any) => {
                       
                        totalpendingbills=totalpendingbills+1;
                       
                       
                        
              })
    
              insurancebalance=insurancebalance+parseFloat(account?.insuranceBalance);
              patientbalance=patientbalance+parseFloat(account?.patientBalance);
              
    
            })


        }
        
        pendingbills['totalpendingbills'] = totalpendingbills;
        pendingbills['totalbalance'] =String(patientbalance).toLocaleString('en-US');
        pendingbills['insurancebalance'] = String(insurancebalance).toLocaleString('en-US');
        result.bills = pendingbills;
    return result;
}